import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

/**
 * Meridian has no dark variant, so a custom install is light-only.
 *
 * This is the design's decision, not a shortcut: neither the plan branch nor
 * the develop prototype contains a single dark-mode rule, and the palette is
 * one flat warm-neutral ramp with a black accent. Honouring the OS preference
 * on a custom install produced the worst of both — the Meridian chrome kept its
 * own scoped tokens and stayed light while every stock screen hosted inside the
 * shell followed `.dark` and went grey, so one window showed two themes at once.
 *
 * Read straight from the boot config rather than through `useConfig`, because
 * this runs as a plain helper outside any component setup.
 */
const isCustomInstall = () => window.chatwootConfig?.isCustom === 'true';

export const setColorTheme = isOSOnDarkMode => {
  if (isCustomInstall()) {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
    return;
  }

  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
  if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};
